import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/forgot', component: () => import('@/views/forgot/index'), hidden: true },
  { path: '/response/:email', component: () => import('@/views/forgot/response'), hidden: true },
  { path: '/login', component: () => import('@/views/login/new'), hidden: true },
  // { path: '/loginnew', component: () => import('@/views/login/new'), hidden: true },
  // { path: '/login/staff', component: () => import('@/views/login/staff'), hidden: true },
  { path: '/register', component: () => import('@/views/register/new'), hidden: true },
  // { path: '/registernew', component: () => import('@/views/register/new'), hidden: true },
  { path: '/reset', component: () => import('@/views/forgot/reset'), hidden: true },
  { path: '/success', component: () => import('@/views/forgot/success'), hidden: true },
  { path: '/faq', component: () => import('@/views/faq/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/landingpagepart3', component: () => import('@/views/home/oldlandingpagepart3base'), hidden: true },
  { path: '/v1', component: () => import('@/views/home/oldlandingpagepart3base'), hidden: true },
  // { path: '/v1', component: () => import('@/views/home/v1'), hidden: true },
  { path: '/v2', component: () => import('@/views/home/(old)index'), hidden: true },
  // { path: '/framerv2', component: () => import('@/views/home/newlandingpagev2combined'), hidden: true },
  // { path: '/v3', component: () => import('@/views/home/v3'), hidden: true },
  // { path: '/v4', component: () => import('@/views/home/v4'), hidden: true },
  { path: '/confirmation', component: () => import('@/views/home/confirmation'), hidden: true },
  { path: '/confirmation-success', component: () => import('@/views/home/confirmation-success'), hidden: true },
  // { path: '/legal', component: () => import('@/views/legal/legal'), hidden: true },
  { path: '/legal', component: () => import('@/views/legal/legal-replacement'), hidden: true },
  // { path: '/privacy', component: () => import('@/views/legal/privacy'), hidden: true },
  { path: '/privacy', component: () => import('@/views/legal/privacy-replacement'), hidden: true },
  // { path: '/cookie', component: () => import('@/views/legal/cookie'), hidden: true },
  { path: '/cookie', component: () => import('@/views/legal/cookie-replacement'), hidden: true },
  { path: '/unconfirmed', component: () => import('@/views/unconfirmed/index'), hidden: true },
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const adminWaitingRouterMap = [
  { path: '/z/:branchId/default', component: () => import('@/views/unconfirmed/adminwaiting'), hidden: true }
]

export const asyncRouterMap = [
  {
    path: '/z/:branchId/msma/overview',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { feature: 'msma', title: 'Overview', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/msma/general/overviewnew'),
        meta: { title: 'Smart Factory Recognition Program', icon: 'ow_clock1' }
      },
    ],
    hidden: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/msma/overviewnew',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Smart Factory Recognition Program',
  //   meta: { feature: 'msma', title: 'Overview', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/msma/general/overviewnew'),
  //       meta: { title: 'Smart Factory Recognition Program', icon: 'ow_clock1' }
  //     },
  //   ],
  //   hidden: true,
  //   branch: true
  // },
  {
    path: '/z/:branchId/msma/applicant',
    component: Layout,
    redirect: '',
    name: 'Dashboard',
    meta: { relationRoles: ['Owner'], stuModule: 'applicant', feature: 'msma', title: 'Dashboard' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/msma/applicant/selfassessmentsuser_form'),
        meta: { title: '01 Self-Assessment' }
      },
      {
        path: 'selfassessmentsresult',
        component: () => import('@/views/msma/applicant/selfassessmentsresult'),
        meta: { title: '02 Results and Eligibility Summary' }
      },
      {
        path: 'companyinformation',
        component: () => import('@/views/msma/applicant/companyinformation'),
        meta: { title: '03 Company Information' }
      },
      {
        path: 'detailedresult',
        component: () => import('@/views/msma/applicant/detailedresult'),
        meta: { relationRoles: ['sirimassessornowner', 'Owner'], title: 'Detailed Result Page' },
        hidden: true
      },
    ],
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/msma/applicant',
  //   component: Layout,
  //   redirect: '',
  //   name: '02 Project Flow',
  //   meta: { relationRoles: ['Owner'], stuModule: 'applicant', feature: 'msma', title: '02 Project Flow' },
  //   children: [
  //     {
  //       path: 'company_projectapplication',
  //       component: () => import('@/views/msma/projectflow/company_projectapplication'),
  //       meta: { title: 'Project Application' }
  //     },
  //     {
  //       path: 'company_conceptproposal',
  //       component: () => import('@/views/msma/projectflow/company_conceptproposal_empty'),
  //       meta: { title: 'Concept Proposal' }
  //     },
  //     {
  //       path: 'company_ciselection',
  //       component: () => import('@/views/msma/projectflow/company_ciselection'),
  //       meta: { title: 'CI Selection' }
  //     },
  //     {
  //       path: 'company_projectimplementation',
  //       component: () => import('@/views/msma/projectflow/company_projectimplementation_empty'),
  //       meta: { title: 'Project Implementation' }
  //     },
  //     {
  //       path: 'company_projectcompletion',
  //       component: () => import('@/views/msma/projectflow/company_projectcompletion_empty'),
  //       meta: { title: 'Project Completion' }
  //     },
  //     {
  //       path: 'company_postprojectaudit',
  //       component: () => import('@/views/msma/projectflow/company_postprojectaudit_empty'),
  //       meta: { title: 'Post Project Audit' }
  //     },
  //   ],
  //   alwaysShow: true,
  //   branch: true
  // },
  {
    path: '/z/:branchId/msma/assessor',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['sirimassessor', 'sirimassnpm', 'sirimprojectmanager', 'sirimassessornowner'], feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/msma/general/home'),
        meta: { relationRoles: ['sirimassessor', 'sirimassnpm', 'sirimprojectmanager', 'sirimassessornowner'], title: 'Home' }
      },
      {
        path: 'assessorosfa',
        component: () => import('@/views/msma/assessor/assessorosfa'),
        meta: { relationRoles: ['sirimassessor', 'sirimassnpm'], title: '01 Assessor OSFA' }
      },
      {
        path: 'selfassessment_assessor',
        component: () => import('@/views/msma/assessor/selfassessmentsassessor_form'),
        meta: { relationRoles: ['sirimassessor', 'sirimassnpm'], title: '02 Onsite Assessment' },
        hidden: true
      },
      {
        path: 'assessordraftreport',
        component: () => import('@/views/msma/assessor/assessordraftreport'),
        meta: { relationRoles: ['sirimassessor', 'sirimassnpm'], title: '03 Draft Report' },
        hidden: true
      },
      {
        path: 'assessorprelimreport',
        component: () => import('@/views/msma/assessor/assessorprelimreport'),
        meta: { relationRoles: ['sirimassessor', 'sirimassnpm'], title: '04 Prelim Report' },
        hidden: true
      },
      {
        path: 'assessorpreviewreport',
        component: () => import('@/views/msma/assessor/assessorpreviewreport'),
        meta: { relationRoles: ['sirimassessor', 'sirimassnpm'], title: '05 Assessor Report' },
        hidden: true
      },
      {
        path: 'declaration',
        component: () => import('@/views/msma/applicant/declaration'),
        meta: { relationRoles: ['sirimassessornowner'], title: '01 COMPANY Declaration' }
      },
      {
        path: 'companyinformation',
        component: () => import('@/views/msma/applicant/companyinformation'),
        meta: { relationRoles: ['sirimassessornowner'], title: '02 COMPANY Company Information' }
      },
      {
        path: 'selfassessments',
        component: () => import('@/views/msma/applicant/selfassessmentsuser_form'),
        meta: { relationRoles: ['sirimassessornowner'], title: '03 COMPANY Self-Assessment' }
      },
      {
        path: 'selfassessmentsresult',
        component: () => import('@/views/msma/applicant/selfassessmentsresult'),
        meta: { relationRoles: ['sirimassessornowner'], title: '04 COMPANY Results and Eligibility Summary' }
      },
      {
        path: 'selfassessmentsresult_register',
        component: () => import('@/views/msma/applicant/selfassessmentsresult_register'),
        meta: { relationRoles: ['sirimassessornowner'], title: '05 COMPANY Register Smart Factory Recognition Program' }
      },
      {
        path: 'onsiteassessment',
        component: () => import('@/views/msma/applicant/onsiteassessment'),
        meta: { relationRoles: ['sirimassessornowner'], title: '06 COMPANY Onsite Assessment' }
      },
      {
        path: 'assessorosfa',
        component: () => import('@/views/msma/assessor/assessorosfa'),
        meta: { relationRoles: ['sirimassessornowner'], title: '07 ASSESSOR Onsite Assessments' }
      },
      {
        path: 'selfassessment_assessor',
        component: () => import('@/views/msma/assessor/selfassessmentsassessor_form'),
        meta: { relationRoles: ['sirimassessornowner'], title: '08 ASSESSOR Onsite Assessment' },
        hidden: true
      },
      {
        path: 'assessorprelimreport',
        component: () => import('@/views/msma/assessor/assessorprelimreport'),
        meta: { relationRoles: ['sirimassessornowner'], title: '09 ASSESSOR/COMPANY Prelim Report' },
        hidden: true
      },
      {
        path: 'assessordraftreport',
        component: () => import('@/views/msma/assessor/assessordraftreport'),
        meta: { relationRoles: ['sirimassessornowner'], title: '10 ASSESSOR Draft Report' },
        hidden: true
      },
      {
        path: 'assessorpreviewreport',
        component: () => import('@/views/msma/assessor/assessorpreviewreport'),
        meta: { relationRoles: ['sirimassessornowner'], title: '11 ASSESSOR Assessor Report' },
        hidden: true
      },
      {
        path: 'pmproject',
        component: () => import('@/views/msma/projectflow/pmproject'),
        meta: { relationRoles: ['sirimassnpm', 'sirimprojectmanager'], title: '02 PM Project' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/msma/assessor',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['sirimdmunassnpm'], feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'selfassessment_assessor',
        component: () => import('@/views/msma/assessor/selfassessmentsassessor_form'),
        meta: { relationRoles: ['sirimdmunassnpm'], title: '02 Onsite Assessment' },
        hidden: true
      },
      {
        path: 'assessordraftreport',
        component: () => import('@/views/msma/assessor/assessordraftreport'),
        meta: { relationRoles: ['sirimdmunassnpm'], title: '03 Draft Report' },
        hidden: true
      },
      {
        path: 'assessorprelimreport',
        component: () => import('@/views/msma/assessor/assessorprelimreport'),
        meta: { relationRoles: ['sirimdmunassnpm'], title: '04 Prelim Report' },
        hidden: true
      },
      {
        path: 'assessorpreviewreport',
        component: () => import('@/views/msma/assessor/assessorpreviewreport'),
        meta: { relationRoles: ['sirimdmunassnpm'], title: '05 Assessor Report' },
        hidden: true
      }
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/msma/technicalcommittee',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['technicalcommitteemember', 'technicalcommitteechairman'], feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/msma/general/home'),
        meta: { title: 'Home' }
      },
      {
        path: 'tacproject',
        component: () => import('@/views/msma/projectflow/tacproject'),
        meta: { relationRoles: ['technicalcommitteemember'], title: '01 TAC Concept Proposal' }
      },
      {
        path: 'chairmanproject',
        component: () => import('@/views/msma/projectflow/chairmanproject'),
        meta: { relationRoles: ['technicalcommitteechairman'], title: '01 TAC Concept Proposal' }
      }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/msma/dashboard',
    component: Layout,
    redirect: '',
    name: 'Dashboard',
    meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager', 'miti'], feature: 'msma', title: 'Dashboard' },
    children: [
      {
        path: 'dmudashboard_main',
        component: () => import('@/views/msma/dmu/dmudashboard_main'),
        meta: { title: 'Main' },
      },
      {
        path: 'dmudashboard_company',
        component: () => import('@/views/msma/dmu/dmudashboard_company'),
        meta: { title: 'Company Profile and Self Assessment' },
      },
      // {
      //   path: 'dmudashboard_allcompanies',
      //   component: () => import('@/views/msma/dmu/dmudashboard_allcompanies'),
      //   meta: { title: 'All Company Profiles' }
      // },
      {
        path: 'dmudashboard_osfa',
        component: () => import('@/views/msma/dmu/dmudashboard_osfa'),
        meta: { title: 'OSFA' }
      },
      {
        path: 'dmudashboard_project',
        component: () => import('@/views/msma/dmu/dmudashboard_project'),
        meta: { title: 'Project' },
      },
      {
        path: 'dmudashboard_operation',
        component: () => import('@/views/msma/dmu/dmudashboard_operation'),
        meta: { title: 'Operational Dashboard' }
      },
      {
        path: 'dmudashboard_collaborator',
        component: () => import('@/views/msma/dmu/dmudashboard_collaborator'),
        meta: { title: 'Collaborator' }
      },
      {
        path: 'dmureporting',
        component: () => import('@/views/msma/dmu/dmureporting'),
        meta: { title: 'Reporting' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/msma/dmu',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'dmuosfa',
        component: () => import('@/views/msma/dmu/dmuosfa'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '01 DMT OSFA' }
      },
      {
        path: 'assessorosfa',
        component: () => import('@/views/msma/assessor/assessorosfa'),
        meta: { relationRoles: ['sirimdmunassnpm'], title: '01 Assessor OSFA' }
      },
      // {
      //   path: 'codestructor-dmuosfa-sample',
      //   component: () => import('@/views/msma/dmu/codestructor-dmuosfa-sample'),
      //   meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '*SAMPLE* DMT OSFA' }
      // },
      {
        path: 'dmuci',
        component: () => import('@/views/msma/dmu/dmuci'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '02 DMT CI' }
      },
      {
        path: 'dmupreviewreport',
        component: () => import('@/views/msma/dmu/dmupreviewreport'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '03 Assessor Report' },
        hidden: true
      },
      {
        path: 'dmuprelimreport',
        component: () => import('@/views/msma/dmu/dmuprelimreport'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '04 Assessor Report' },
        hidden: true
      },
      {
        path: 'dmuproject',
        component: () => import('@/views/msma/projectflow/dmuproject'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '03 DMT Project' },
      },
      {
        path: 'pmproject',
        component: () => import('@/views/msma/projectflow/pmproject'),
        meta: { relationRoles: ['sirimdmunassnpm'], title: '03 PM Project' }
      },
      {
        path: 'tacprojectsecretariat',
        component: () => import('@/views/msma/projectflow/tacprojectsecretariat'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '04 TAC Secretariat' }
      },
      {
        path: 'approvalcommitteeproject',
        component: () => import('@/views/msma/projectflow/approvalcommitteeproject'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: '05 Approval Committee Project' },
        hidden: true
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/msma/projectflow',
    component: Layout,
    redirect: '',
    name: 'Project Flow',
    meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], feature: 'msma', title: '*NEW* Project Flow' },
    children: [
      {
        path: 'tacproject',
        component: () => import('@/views/msma/projectflow/tacproject'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: 'TAC Project' },
        hidden: true
      },
      {
        path: 'chairmanproject',
        component: () => import('@/views/msma/projectflow/chairmanproject'),
        meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], title: 'Chairman of TAC - Project' },
        hidden: true
      },
      // {
      //   path: 'company_projectapplication',
      //   component: () => import('@/views/msma/projectflow/company_projectapplication'),
      //   meta: { title: 'Project Application' },
      //   hidden: true
      // },
      {
        path: 'company_conceptproposal',
        component: () => import('@/views/msma/projectflow/company_conceptproposal'),
        meta: { title: 'Concept Proposal' },
        hidden: true
      },
      {
        path: 'tacproject_duplicate',
        component: () => import('@/views/msma/projectflow/tacproject_duplicate'),
        meta: { title: 'TAC Project Duplicate' },
        hidden: true
      },
    ],
    // alwaysShow: true,
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/payment',
    component: Layout,
    redirect: '',
    name: 'Payment',
    meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], feature: 'msma', title: 'Payment' },
    children: [
      {
        path: 'eghlresponses',
        component: () => import('@/views/msma/dmu/eghlresponses'),
        meta: { title: 'eGHL Logs' }
      },
      {
        path: 'uploadedreceipts',
        component: () => import('@/views/msma/dmu/uploadedreceipts'),
        meta: { title: 'Uploaded Receipts' },
        hidden: true
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/msma/financialinstitution',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['financialinstitution'], feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/msma/general/home'),
        meta: { title: 'Home' }
      },
      {
        path: 'fiosfa',
        component: () => import('@/views/msma/financialinstitution/fiosfa'),
        meta: { title: 'Loan Eligibility' }
      },
      {
        path: 'fiprojectfunding',
        component: () => import('@/views/msma/projectflow/fiprojectfunding'),
        meta: { title: 'Project Funding' }
      },
      {
        path: 'financialinstitutionsettings',
        component: () => import('@/views/msma/financialinstitution/financialinstitutionsettings'),
        meta: { title: 'Settings' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/msma/crowdinnovator',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['Owner'], stuModule: 'crowdinnovator', feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/msma/crowdinnovator/home'),
        meta: { title: 'Home' }
      },
      {
        path: 'crowdinnovator_application',
        component: () => import('@/views/msma/crowdinnovator/ciapplication'),
        meta: { title: 'CI Application' }
      },
      {
        path: 'ciproject',
        component: () => import('@/views/msma/projectflow/ciproject'),
        meta: { title: '01 CI Project' }
      },
      // {
      //   path: 'crowdinnovator_application_alternate',
      //   component: () => import('@/views/msma/crowdinnovator/ciapplicationalternate'),
      //   meta: { title: 'CI Application Alt' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/msma/projectleader',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['sirimprojectleader'], feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/msma/general/home'),
        meta: { title: 'Home' }
      },
    ]
  },
  {
    path: '/z/:branchId/msma/projectmanager',
    component: Layout,
    redirect: '',
    name: 'Smart Factory Recognition Program',
    meta: { relationRoles: ['sirimprojectmanager'], feature: 'msma', title: 'Smart Factory Recognition Program' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/msma/general/home'),
        meta: { title: 'Home' }
      },
    ]
  },
  {
    path: '/z/:branchId/profile',
    component: Layout,
    redirect: '',
    name: 'Profile',
    meta: { relationRoles: ['sirimassessor', 'sirimassnpm', 'sirimdmunassnpm', 'sirimprojectmanager', 'sirimassessornowner'], feature: 'msma', title: 'Profile' },
    children: [
      {
        path: 'editsirimprofile',
        component: () => import('@/views/msma/general/editsirimprofile'),
        meta: { relationRoles: ['sirimassessor', 'sirimassnpm', 'sirimdmunassnpm', 'sirimprojectmanager', 'sirimassessornowner'], title: 'Edit SIRIM Profile' },
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { relationRoles: ['sirimdmu', 'sirimdmunassnpm', 'sirimrolemanager'], feature: 'msma', title: 'Register' },
    children: [
      {
        path: 'registerdepartment',
        component: () => import('@/views/msma/dmu/registerdepartment'),
        meta: { title: 'Register Department/Section' },
      },
      {
        path: 'registersirimstaff',
        component: () => import('@/views/msma/dmu/registersirimstaff'),
        meta: { title: 'Register SIRIM Staffs' },
      },
      {
        path: 'registeredusers',
        component: () => import('@/views/msma/dmu/registeredusers'),
        meta: { title: 'Registered Users (non-SIRIM)' },
      },
      {
        path: 'dashboardregistrations',
        component: () => import('@/views/msma/dmu/dashboardregistrations'),
        meta: { title: 'Register Dashboard Registrations' }
      },
      {
        path: 'dmutestdashboard',
        component: () => import('@/views/msma/dmu/dmutestdashboard'),
        meta: { title: 'Test Dashboard' }
      },
      // {
      //   path: 'dmutestdashboard2',
      //   component: () => import('@/views/msma/dmu/dmutestdashboard2'),
      //   meta: { title: 'Test Dashboard 2' }
      // },
      {
        path: 'dmutestdashboard3',
        component: () => import('@/views/msma/dmu/dmutestdashboard3'),
        meta: { title: 'Test Dashboard 2' }
      },
      {
        path: 'firequirementsettings',
        component: () => import('@/views/msma/dmu/firequirementsettings'),
        meta: { title: 'Settings FI Requirements' }
      },
      {
        path: 'deadlineholidays',
        component: () => import('@/views/msma/deadlineholidays'),
        meta: { title: 'Deadline Holidays' }
      }
    ],
    branch: true
  },

  // default - has branch
  // {
  //   path: '/z/:branchId/branch',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'Co. Settings',
  //   meta: { title: 'Co. Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/branch/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'email',
  //       component: () => import('@/views/settings/branch/email'),
  //       meta: { title: 'Email' }
  //     },
  //     {
  //       path: 'collaborator',
  //       component: () => import('@/views/settings/branch/collaborator'),
  //       meta: { title: 'Collaborator' }
  //     }
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/account',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'User Settings',
  //   meta: { title: 'User Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/user/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'password',
  //       component: () => import('@/views/settings/user/password'),
  //       meta: { title: 'Password' }
  //     }
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/default',
    component: Layout,
    redirect: '',
    name: 'Default',
    meta: { title: 'Default' },
    children: [
      {
        path: '',
        component: () => import('@/views/admin/default/index'),
        meta: { title: 'Default' }
      }
    ],
    hidden: true,
    branch: true
  },

  // default - no branch
  // {
  //   path: '/branch',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'Co. Settings',
  //   meta: { title: 'Co. Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/branch/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'email',
  //       component: () => import('@/views/settings/branch/email'),
  //       meta: { title: 'Email' }
  //     },
  //     {
  //       path: 'collaborator',
  //       component: () => import('@/views/settings/branch/collaborator'),
  //       meta: { title: 'Collaborator' }
  //     }
  //   ]
  // },
  // {
  //   path: '/account',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'User Settings',
  //   meta: { title: 'User Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/user/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'password',
  //       component: () => import('@/views/settings/user/password'),
  //       meta: { title: 'Password' }
  //     }
  //   ]
  // },
  // {
  //   path: '/email',
  //   component: Layout,
  //   redirect: 'email',
  //   name: 'Email',
  //   meta: { title: 'Email' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/email/index'),
  //       meta: { title: 'Email' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: 'dashboard',
  //   name: 'Dashboard',
  //   meta: { title: 'Dashboard' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
  //   },
  //   {
  //     path: 'instance',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     name: 'New Instance',
  //     meta: { title: 'New Instance' },
  //     hidden: true
  //   }]
  // },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: ['generalmanager'], title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users' }
    }]
  }
  // { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js